export const actionTypes = {
  GET_LIST_RECIPES: 'GET_LIST_RECIPE',
  GET_LIST_RECIPES_SUCCESS: 'GET_LIST_RECIPE_SUCCESS',
  GET_LIST_RECIPES_FAIL: 'GET_LIST_RECIPE_FAIL',

  CREATE_RECIPE: 'CREATE_RECIPE',
  CREATE_RECIPE_SUCCESS: 'CREATE_RECIPE_SUCCESS',
  CREATE_RECIPE_FAIL: 'CREATE_RECIPE_FAIL',

  UPDATE_RECIPE: 'UPDATE_RECIPE',
  UPDATE_RECIPE_SUCCESS: 'UPDATE_RECIPE_SUCCESS',
  UPDATE_RECIPE_FAIL: 'UPDATE_RECIPE_FAIL',

  GET_RECIPE_DETAIL: "GET_RECIPE_DETAIL",
  GET_RECIPE_DETAIL_SUCCESS: "GET_RECIPE_DETAIL_SUCCESS",
  GET_RECIPE_DETAIL_FAIL: "GET_RECIPE_DETAIL_FAIL",

  CREATE_INSTRUCTION: 'CREATE_INSTRUCTION',
  CREATE_INSTRUCTION_SUCCESS: 'CREATE_INSTRUCTION_SUCCESS',
  CREATE_INSTRUCTION_FAIL: 'CREATE_INSTRUCTION_FAIL',

  UPDATE_INSTRUCTION: 'UPDATE_INSTRUCTION',
  UPDATE_INSTRUCTION_SUCCESS: 'UPDATE_INSTRUCTION_SUCCESS',
  UPDATE_INSTRUCTION_FAIL: 'UPDATE_INSTRUCTION_FAIL',

  ORDER_INSTRUCTION: "ORDER_INSTRUCTION",
  ORDER_INSTRUCTION_SUCCESS: "ORDER_INSTRUCTION_SUCCESS",
  ORDER_INSTRUCTION_FAIL: "ORDER_INSTRUCTION_FAIL",

  DELETE_INSTRUCTION: "DELETE_INSTRUCTION",
  DELETE_INSTRUCTION_SUCCESS: "DELETE_INSTRUCTION_SUCCESS",
  DELETE_INSTRUCTION_FAIL: "DELETE_INSTRUCTION_FAIL",

  CREATE_INGREDIENT: 'CREATE_INGREDIENT',
  CREATE_INGREDIENT_SUCCESS: 'CREATE_INGREDIENT_SUCCESS',
  CREATE_INGREDIENT_FAIL: 'CREATE_INGREDIENT_FAIL',

  UPDATE_INGREDIENT: 'UPDATE_INGREDIENT',
  UPDATE_INGREDIENT_SUCCESS: 'UPDATE_INGREDIENT_SUCCESS',
  UPDATE_INGREDIENT_FAIL: 'UPDATE_INGREDIENT_FAIL',

  ORDER_INGREDIENT: "ORDER_INGREDIENT",
  ORDER_INGREDIENT_SUCCESS: "ORDER_INGREDIENT_SUCCESS",
  ORDER_INGREDIENT_FAIL: "ORDER_INGREDIENT_FAIL",

  DELETE_INGREDIENT: "DELETE_INGREDIENT",
  DELETE_INGREDIENT_SUCCESS: "DELETE_INGREDIENT_SUCCESS",
  DELETE_INGREDIENT_FAIL: "DELETE_INGREDIENT_FAIL",

  DELETE_RECIPE: 'DELETE_RECIPE',
  DELETE_RECIPE_SUCCESS: 'DELETE_RECIPE_SUCCESS',
  DELETE_RECIPE_FAIL: 'DELETE_RECIPE_FAIL',

  DELETE_IMAGE_RECIPE: 'DELETE_IMAGE_RECIPE',
  DELETE_IMAGE_RECIPE_SUCCESS: 'DELETE_IMAGE_RECIPE_SUCCESS',
  DELETE_IMAGE_RECIPE_FAIL: 'DELETE_IMAGE_RECIPE_FAIL',

  CLEAR_LIST_RECIPE: 'CLEAR_LIST_RECIPE'
};

export const actions = {
  clearListRecipe: () => ({
    type: actionTypes.CLEAR_LIST_RECIPE
  }),
  getListRecipes: () => ({
    type: actionTypes.GET_LIST_RECIPES,
  }),
  getListRecipesSuccess: (data: any) => ({
    type: actionTypes.GET_LIST_RECIPES_SUCCESS,
    payload: data,
  }),
  getListRecipesFail: (err: any) => ({
    type: actionTypes.GET_LIST_RECIPES_FAIL,
    payload: err,
  }),

  createRecipe: () => ({
    type: actionTypes.CREATE_RECIPE,
  }),
  createRecipeSuccess: (data: any) => ({
    type: actionTypes.CREATE_RECIPE_SUCCESS,
    payload: data,
  }),
  createRecipeFail: (err: any) => ({
    type: actionTypes.CREATE_RECIPE_FAIL,
    payload: err,
  }),

  updateRecipe: () => ({
    type: actionTypes.UPDATE_RECIPE,
  }),
  updateRecipeSuccess: (data: any) => ({
    type: actionTypes.UPDATE_RECIPE_SUCCESS,
    payload: data,
  }),
  updateRecipeFail: (err: any) => ({
    type: actionTypes.UPDATE_RECIPE_FAIL,
    payload: err,
  }),

  getRecipeDetail: () => ({
    type: actionTypes.GET_RECIPE_DETAIL,
  }),
  getRecipeDetailSuccess: (data: any) => ({
    type: actionTypes.GET_RECIPE_DETAIL_SUCCESS,
    payload: data,
  }),
  getRecipeDetailFail: (err: any) => ({
    type: actionTypes.GET_RECIPE_DETAIL_FAIL,
    payload: err,
  }),

  createInstruction: () => ({
    type: actionTypes.CREATE_INSTRUCTION,
  }),
  createInstructionSuccess: (data: any) => ({
    type: actionTypes.CREATE_INSTRUCTION_SUCCESS,
    payload: data,
  }),
  createInstructionFail: (err: any) => ({
    type: actionTypes.CREATE_INSTRUCTION_FAIL,
    payload: err,
  }),

  updateInstruction: () => ({
    type: actionTypes.UPDATE_INSTRUCTION,
  }),
  updateInstructionSuccess: (data: any) => ({
    type: actionTypes.UPDATE_INSTRUCTION_SUCCESS,
    payload: data,
  }),
  updateInstructionFail: (err: any) => ({
    type: actionTypes.UPDATE_INSTRUCTION_FAIL,
    payload: err,
  }),

  orderInstruction: () => ({
    type: actionTypes.ORDER_INSTRUCTION,
  }),
  orderInstructionSuccess: (data: any) => ({
    type: actionTypes.ORDER_INSTRUCTION_SUCCESS,
    payload: data,
  }),
  orderInstructionFail: (err: any) => ({
    type: actionTypes.ORDER_INSTRUCTION_FAIL,
    payload: err,
  }),

  deleteInstruction: () => ({
    type: actionTypes.DELETE_INSTRUCTION,
  }),
  deleteInstructionSuccess: (data: any) => ({
    type: actionTypes.DELETE_INSTRUCTION_SUCCESS,
    payload: data,
  }),
  deleteInstructionFail: (err: any) => ({
    type: actionTypes.DELETE_INSTRUCTION_FAIL,
    payload: err,
  }),

  createIngredient: () => ({
    type: actionTypes.CREATE_INGREDIENT,
  }),
  createIngredientSuccess: (data: any) => ({
    type: actionTypes.CREATE_INGREDIENT_SUCCESS,
    payload: data,
  }),
  createIngredientFail: (err: any) => ({
    type: actionTypes.CREATE_INGREDIENT_FAIL,
    payload: err,
  }),

  updateIngredient: () => ({
    type: actionTypes.UPDATE_INGREDIENT,
  }),
  updateIngredientSuccess: (data: any) => ({
    type: actionTypes.UPDATE_INGREDIENT_SUCCESS,
    payload: data,
  }),
  updateIngredientFail: (err: any) => ({
    type: actionTypes.UPDATE_INGREDIENT_FAIL,
    payload: err,
  }),

  orderIngredient: () => ({
    type: actionTypes.ORDER_INGREDIENT,
  }),
  orderIngredientSuccess: (data: any) => ({
    type: actionTypes.ORDER_INGREDIENT_SUCCESS,
    payload: data,
  }),
  orderIngredientFail: (err: any) => ({
    type: actionTypes.ORDER_INGREDIENT_FAIL,
    payload: err,
  }),

  deleteIngredient: () => ({
    type: actionTypes.DELETE_INGREDIENT,
  }),
  deleteIngredientSuccess: (data: any) => ({
    type: actionTypes.DELETE_INGREDIENT_SUCCESS,
    payload: data,
  }),
  deleteIngredientFail: (err: any) => ({
    type: actionTypes.DELETE_INGREDIENT_FAIL,
    payload: err,
  }),

  deleteRecipe: () => ({
    type: actionTypes.DELETE_RECIPE,
  }),
  deleteRecipeSuccess: (data: any) => ({
    type: actionTypes.DELETE_RECIPE_SUCCESS,
    payload: data,
  }),
  deleteRecipeFail: (err: any) => ({
    type: actionTypes.DELETE_RECIPE_FAIL,
    payload: err,
  }),

  deleteImageRecipe: () => ({
    type: actionTypes.DELETE_IMAGE_RECIPE,
  }),
  deleteImageRecipeSuccess: (data: any) => ({
    type: actionTypes.DELETE_IMAGE_RECIPE_SUCCESS,
    payload: data,
  }),
  deleteImageRecipeFail: (err: any) => ({
    type: actionTypes.DELETE_IMAGE_RECIPE_FAIL,
    payload: err,
  }),
};
